function getDistanceToBottom() {
    const section = document.querySelector('.banner-scroll__container');
    if (!section) {
        console.error('Section banner-scroll non trouvée');
        return;
    }

    // Position du bas de la section par rapport au haut de la fenêtre
    const sectionBottom = section.getBoundingClientRect().bottom;
    // Position de défilement actuelle
    const scrollY = window.scrollY;
    // Hauteur totale de la page
    const pageHeight = document.documentElement.scrollHeight;
    // Hauteur de la fenêtre
    const viewportHeight = window.innerHeight;

    // Position absolue du bas de la section dans le document
    const sectionBottomAbsolute = sectionBottom + scrollY;
    // Distance entre le bas de la section et le bas de la page
    const distanceToBottom = pageHeight - sectionBottomAbsolute;

    //   assign to --rest-distance-to-bottom CSS variable
    document.documentElement.style.setProperty('--rest-distance-to-bottom', `${distanceToBottom}px`);
}

// Appeler la fonction
window.addEventListener('load', getDistanceToBottom);
window.addEventListener('resize', getDistanceToBottom);

class CollectionJs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {

        this.querySelectorAll('.collection__navigation button').forEach(button => {
            button.addEventListener('click', () => {
                const filter = button.getAttribute('data-product-handle');
                this.querySelectorAll('.collection__navigation button').forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');
                this.querySelectorAll('.collection__products .product-card').forEach(item => {
                    if (item.getAttribute('data-product-handle') == filter || filter === 'all') {
                        item.classList.remove('hidden');
                    } else {
                        item.classList.add('hidden');
                    }
                });
            });
        });
    }
}

customElements.define('collection-js', CollectionJs);


async function addToCart(variantId, quantity = 1, properties = null) {
    const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const finalProperties = { ...(properties || {}), _random: randomId };

    const payload = { id: variantId, quantity, properties: finalProperties };

    const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin',
    });

    if (!res.ok) {
        const error = await res.json().catch(() => ({}));
        throw new Error(error?.description || 'Impossible d’ajouter au panier.');
    }

    // Rafraîchir le side-cart (méthode ou event, selon ton implémentation)
    const sideCart = document.querySelector('side-cart');
    try {
        if (sideCart && typeof sideCart.refreshcart === 'function') {
            await sideCart.refreshcart(); // méthode directe
        } else if (sideCart) {
            sideCart.dispatchEvent(new CustomEvent('refreshcart', { bubbles: true })); // fallback par event
        }
    } catch (e) {
        console.warn('refreshcart a échoué ou est indisponible:', e);
    }

    return res.json();
}


function bindAddToCartButtons(root = document) {
    root.querySelectorAll('button[add-to-cart]').forEach((btn) => {
        // éviter les double-bind si du contenu est réinjecté
        if (btn._hasAtcListener) return;
        btn._hasAtcListener = true;

        btn.addEventListener('click', async (e) => {
            e.preventDefault();

            const variantId = btn.getAttribute('data-variant-id');
            const qty = parseInt(btn.getAttribute('data-quantity') || '1', 10);

            if (!variantId) {
                console.error('Pas de data-variant-id sur le bouton add-to-cart');
                return;
            }

            const originalText = btn.textContent;
            btn.disabled = true;
            btn.setAttribute('aria-busy', 'true');
            btn.textContent = 'AJOUT...';

            try {
                await addToCart(variantId, qty);
                btn.textContent = 'AJOUTÉ !';
                // Optionnel: réouvrir/afficher le side-cart si tu as une API dédiée (ex: sideCart.open())
                // const sideCart = document.querySelector('side-cart'); sideCart?.open?.();
                await document.querySelector('side-cart').refreshCart();
            } catch (err) {
                console.error(err);
                btn.textContent = 'Erreur';
            } finally {
                setTimeout(() => {
                    btn.disabled = false;
                    btn.removeAttribute('aria-busy');
                    btn.textContent = originalText;
                }, 1200);
            }
        });
    });
}




window.addEventListener('DOMContentLoaded', () => bindAddToCartButtons());
document.addEventListener('shopify:section:load', (e) => bindAddToCartButtons(e.target)); 